// highlight
// material
import { disableCache } from '@iconify/react';
//do not use LocalizationProvider and AdapterDateFns from @mui/lab
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { history } from './routes/history';
// map
import 'mapbox-gl/dist/mapbox-gl.css';
import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
// components
import { LoadingScreen } from './components';
import { AuthProvider } from './contexts/AuthContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
// contexts
import { SettingsProvider } from './contexts/SettingsContext';
// redux
import { persistor, store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import jwtInterceptor from './_helpers/jwt.interceptor';
// scroll bar
import { BrowserRouter } from 'routes/BrowserRouter';
import 'simplebar/src/simplebar.css';

// ----------------------------------------------------------------------

jwtInterceptor();

const Loadable = (Component: React.ElementType) => (props: any) => {
  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            position: 'fixed',
            height: '100vh',
            width: '100vw',
            bottom: 0,
            zIndex: 0,
            right: 0,
            left: 0,
            top: 0
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

const App = Loadable(lazy(() => import('./App')));

ReactDOM.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SettingsProvider>
            <CollapseDrawerProvider>
              <BrowserRouter history={history}>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </CollapseDrawerProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// Disable all caching of iconify icons
disableCache('all');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
